// officeContact — the WHP office phone for the SPA's consumer pages (WEL-171).
//
// Miles, 2026-09-29: the office phone is 509-525-1040, and that number is
// correct everywhere. The verification / RRA forms each hard-coded their own
// `(509) 876-3300` — not the office line. This is the one SPA constant; the API
// has its twin in apps/api/src/lib/officeContact.ts (the browser bundle cannot
// read the API's environment). Keep the two in step.

/** The WHP office line, written the way consumers are told to dial it. */
export const OFFICE_PHONE = '509-525-1040';
